import GuidesSection from './GuidesSection'

export default GuidesSection
